export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    properties: {
      departments: {
        title: 'Departments',
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string'
            },
            department: {
              title: 'Department',
              type: 'string',
              enum: ['Accounting', 'Finance', 'Economics'],
              enumNames: ['Accounting', 'Finance', 'Economics']
            }
          }
        }
      },
      intellcont_auth: {
        title: 'Authors/Editors/Translators',
        description: 'Please order the contributors in the order of contribution.<br/>Please select a person from the drop-down list and/or enter their name in the input fields.',
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string'
            },
            username: {
              title: 'Person at Your University',
              type: 'string',
              enum: ['hbrown'],
              enumNames: ['Henry Brown']
            },
            fname: {
              title: 'First Name',
              type: 'string'
            },
            mname: {
              title: 'Middle Name',
              type: 'string'
            },
            lname: {
              title: 'Last Name',
              type: 'string'
            },
            institution: {
              title: 'Institution/Company',
              type: 'string'
            },
            role: {
              title: 'Role',
              type: 'string',
              enum: ['Author', 'Editor'],
              enumNames: ['Author', 'Editor']
            },
            student_level: {
              title: 'If a student, what is his/her level?',
              type: 'string',
              enum: ['Undergraduate', 'Graduate'],
              enumNames: ['Undergraduate', 'Graduate']
            }
          }
        }
      },
      present_auth: {
        title: 'Presenters/Authors',
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string'
            },
            username: {
              title: 'Person at Your University',
              type: 'string',
              enum: ['hbrown'],
              enumNames: ['Henry Brown']
            },
            fname: {
              title: 'First Name',
              type: 'string'
            },
            mname: {
              title: 'Middle Name',
              type: 'string'
            },
            lname: {
              title: 'Last Name',
              type: 'string'
            },
            role: {
              title: 'Role',
              type: 'string',
              enum: ['Presenter & Author', 'Presenter', 'Author'],
              enumNames: ['Presenter & Author', 'Presenter', 'Author']
            },
            student_level: {
              title: 'If a student, what is his/her level?',
              type: 'string',
              enum: ['Undergraduate', 'Graduate'],
              enumNames: ['Undergraduate', 'Graduate']
            }
          }
        }
      },
      minItemsDsa: {
        title: 'MinItems DSA',
        type: 'array',
        minItems: 2,
        uniqueItems: true,
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string'
            },
            sampleQuestion: {
              title: 'Sample Question',
              type: 'string'
            }
          }
        }
      },
      maxItemsDsa: {
        title: 'MaxItems DSA',
        type: 'array',
        maxItems: 4,
        uniqueItems: true,
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string'
            },
            sampleQuestion: {
              title: 'Sample Question',
              type: 'string'
            }
          }
        }
      },
      minMaxItemsDsa: {
        title: 'Min/Max Items DSA',
        type: 'array',
        minItems: 2,
        maxItems: 4,
        uniqueItems: true,
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string'
            },
            sampleQuestion: {
              title: 'Sample Question',
              type: 'string'
            }
          }
        }
      },
      emptyItemNameDsa: {
        title: 'Empty Item Name in UI Schema',
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string'
            },
            sampleQuestion: {
              title: 'Sample Question',
              type: 'string'
            }
          }
        }
      },
      noItemNameDsa: {
        title: 'No Item Name in UI Schema',
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string'
            },
            sampleQuestion: {
              title: 'Sample Question',
              type: 'string'
            }
          }
        }
      },
      noUiOptionsDsa: {
        title: 'No UI Options in UI Schema',
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string'
            },
            sampleQuestion: {
              title: 'Sample Question',
              type: 'string'
            }
          }
        }
      }
    }
  },
  uiSchema: {
    departments: {
      'ui:options': {
        itemName: 'Department'
      },
      items: {
        department: {
          'ui:widget': 'select'
        },
        'dm:layout': [{
          id: 'department',
          type: 'field'
        }]
      }
    },
    intellcont_auth: {
      'ui:options': {
        itemName: 'Author/Editor/Translator',
        orderable: true
      },
      'ui:title': {
        escape: false
      },
      'ui:description': {
        escape: false
      },
      items: {
        username: {
          'ui:widget': 'select'
        },
        fname: {
          'ui:widget': 'text'
        },
        mname: {
          'ui:widget': 'text'
        },
        lname: {
          'ui:widget': 'text'
        },
        institution: {
          'ui:widget': 'text',
          'ui:help': {
            text: 'Authors who are selected from the drop-down list are known to be at your institution. Therefore, it is only necessary to enter data into this field for authors whose names are entered into the separate name text fields.',
            escape: true
          }
        },
        role: {
          'ui:widget': 'radio'
        },
        student_level: {
          'ui:widget': 'radio'
        },
        'dm:layout': [{
          id: 'username',
          type: 'field'
        }, {
          id: 'fname',
          type: 'field'
        }, {
          id: 'mname',
          type: 'field'
        }, {
          id: 'lname',
          type: 'field'
        }, {
          id: 'institution',
          type: 'field'
        }, {
          id: 'role',
          type: 'field'
        }, {
          id: 'student_level',
          type: 'field'
        }]
      }
    },
    present_auth: {
      'ui:options': {
        orderable: true,
        itemName: 'Presenter/Author'
      },
      'ui:title': {
        escape: false
      },
      'ui:description': {
        escape: false,
        text: 'Please select a person from the drop-down list and/or enter their name in the input fields.'
      },
      items: {
        name_group: {
          'ui:options': {},
          'ui:title': {
            text: '<b>Presenter/Author Name</b>',
            escape: false
          }
        },
        username: {
          'ui:widget': 'select'
        },
        fname: {
          'ui:widget': 'text'
        },
        mname: {
          'ui:widget': 'text'
        },
        lname: {
          'ui:widget': 'text'
        },
        role: {
          'ui:widget': 'radio'
        },
        student_level: {
          'ui:widget': 'radio'
        },
        'dm:layout': [{
          id: 'name_group',
          type: 'group',
          children: [{
            id: 'username',
            type: 'field'
          }, {
            id: 'fname',
            type: 'field'
          }, {
            id: 'mname',
            type: 'field'
          }, {
            id: 'lname',
            type: 'field'
          }]
        }, {
          id: 'role',
          type: 'field'
        }, {
          id: 'student_level',
          type: 'field'
        }]
      }
    },
    minItemsDsa: {
      'ui:options': {
        itemName: 'Item'
      },
      items: {
        sampleQuestion: {
          'ui:widget': 'text'
        },
        'dm:layout': [{
          id: 'sampleQuestion',
          type: 'field'
        }]
      }
    },
    maxItemsDsa: {
      'ui:options': {
        itemName: 'Item'
      },
      items: {
        sampleQuestion: {
          'ui:widget': 'text'
        },
        'dm:layout': [{
          id: 'sampleQuestion',
          type: 'field'
        }]
      }
    },
    minMaxItemsDsa: {
      'ui:options': {
        itemName: 'Item'
      },
      items: {
        sampleQuestion: {
          'ui:widget': 'text'
        },
        'dm:layout': [{
          id: 'sampleQuestion',
          type: 'field'
        }]
      }
    },
    emptyItemNameDsa: {
      'ui:options': {
        itemName: ''
      },
      items: {
        sampleQuestion: {
          'ui:widget': 'text'
        },
        'dm:layout': [{
          id: 'sampleQuestion',
          type: 'field'
        }]
      }
    },
    noItemNameDsa: {
      'ui:options': {},
      items: {
        sampleQuestion: {
          'ui:widget': 'text'
        },
        'dm:layout': [{
          id: 'sampleQuestion',
          type: 'field'
        }]
      }
    },
    noUiOptionsDsa: {
      items: {
        sampleQuestion: {
          'ui:widget': 'text'
        },
        'dm:layout': [{
          id: 'sampleQuestion',
          type: 'field'
        }]
      }
    },
    'dm:layout': [{
      type: 'array',
      id: 'departments'
    }, {
      id: 'intellcont_auth',
      type: 'array'
    }, {
      id: 'present_auth',
      type: 'array'
    }, {
      id: 'minItemsDsa',
      type: 'array'
    }, {
      id: 'maxItemsDsa',
      type: 'array'
    }, {
      id: 'minMaxItemsDsa',
      type: 'array'
    }, {
      id: 'emptyItemNameDsa',
      type: 'array'
    }, {
      id: 'noItemNameDsa',
      type: 'array'
    }, {
      id: 'noUiOptionsDsa',
      type: 'array'
    }]
  },
  formData: {
    departments: [{
      department: 'Accounting'
    }, {
      department: 'Finance'
    }, {
      department: 'Economics'
    }],
    intellcont_auth: [{
      rowId: '12345',
      username: 'hbrown'
    }, {
      rowId: '23456',
      fname: 'Other',
      lname: 'Person'
    }],
    present_auth: [{
      rowId: '12345',
      username: 'hbrown'
    }, {
      rowId: '23456',
      fname: 'Other',
      lname: 'Person'
    }],
    minItemsDsa: [{
      sampleQuestion: 'Min Response 1'
    }],
    maxItemsDsa: [{
      sampleQuestion: 'Max Response 1'
    }],
    minMaxItemsDsa: [{
      sampleQuestion: 'Min/Max Response 1'
    }]
  }
};